import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {QARService, SORUserEntity} from '../services/qar.service';
import {FormControl} from '@angular/forms';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Component({
	selector: 'app-page-approver-overrides',
	templateUrl: './approver-overrides.html',
	providers: [QARService]
})
export class ApproverOverridesPageComponent implements OnInit {

	constructor(public api: QARService) {
	}

	public idFunctionOManagerFirstName(d) {
		return d.OverridenManager?.FirstName;
	}

	public idFunctionOManagerLastName(d) {
		return d.OverridenManager?.LastName;
	}

	ngOnInit(): void {
		this.mapping_init();

		this.mapping.autocomplete$ = this.mapping.sorUserIdFormControl.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				//if (value !== '') {
					return this.aliases_lookup(value);
				/*} else {
					// if no value is present, return null
					return of(null);
				}*/
			}));
		this.mapping.autocompleteApprover$ = this.mapping.sorUserIdFormControlApprover.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				//if (value !== '') {
					return this.aliases_lookup(value);
				/*} else {
					// if no value is present, return null
					return of(null);
				}*/
			}));
	}

	public aliases_lookup(value: string): Observable<SORUserEntity[]> {
		console.log('aliases_lookup',value);
		if (typeof value === 'string') {
			return this.api.searchSORUser(value).pipe(
				// map the item property of the github results as our return object
				map(results => results)
			);
		} else {
			return new Observable<SORUserEntity[]>();
		}
	}

	public mapping = {
		saving: false,
		data: [],
		sorUserIdFormControl: new FormControl(),
		sorUserIdFormControlApprover: new FormControl(),
		chunker: new Chunker([]),
		chunkedData: [],
		loading: false,
		autocomplete$: null,
		autocompleteApprover$: null
	};

	autocompleteDisplayUser(w) {
		if (!w) {
			return '';
		}
		return w.FirstName + ' ' + w.LastName + ' (' + w.Login + ')';
	}

	public mapping_init() {
		this.mapping.loading = true;
		this.api.retrieveApproverOverrides().then(r => {
			this.mapping.loading = false;
			this.mapping.chunker = new Chunker(r);
			this.mapping.data = r;
		}, e => {
			this.alert('Sorry, something went wrong please reload the page');
		});
	}

	mapping_delete(m) {
		this.api.deleteApproverOverride(m.Id).then(r => {
			this.mapping_init();
		}, e => {
			this.alert('Sorry, could not delete at this moment');
		});
	}

	mapping_add() {
		if (!this.mapping.sorUserIdFormControl.value || !this.mapping.sorUserIdFormControl.value.Id) {
			this.alert('Please select a user');
		} else if (!this.mapping.sorUserIdFormControlApprover.value || !this.mapping.sorUserIdFormControlApprover.value.Id) {
			this.alert('Please select an approver');
		} else if (this.mapping.sorUserIdFormControl.value.Id === this.mapping.sorUserIdFormControlApprover.value.Id) {
			this.alert('A User is not permitted to be their own Approver. Please select a different Approver Override user');
		} else {
			this.mapping.saving = true;
			const from = this.mapping.sorUserIdFormControl.value.Id;
			const to = this.mapping.sorUserIdFormControlApprover.value.Id;

			for (const d of this.mapping.data) {
				if (d.Id === from && d.OverridenManagerId === to) {
					this.alert('Sorry, this override is already in place');
					return;
				}
			}

			this.api.saveApproverOverrides(from, to).then(r => {
				this.mapping.saving = false;
				this.mapping_init();
				this.mapping.sorUserIdFormControlApprover.setValue(null);
				this.mapping.sorUserIdFormControl.setValue(null);
			}, e => {
				this.alert('Sorry something went wrong, please reload the page');
			});
		}
	}


	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};

	public comments_save(d:SORUserEntity) {
		this.api.updateApproverOverride(d.Id, d.OverridenManagerComments).then(r => {
			this.mapping_init();
			this.alert('Record has been saved successfully.', '');
		}, e => {
			console.log(e);
			this.alert('Sorry, could not saved at this moment');
		});

		return;
	}

}
